module.exports = __webpack_public_path__ + "img/ic_32_system_apple.2d4bbdce.svg";